export default __webpack_public_path__ + "media/images/background-photo-07e6cf8f89c367bed86810baac453188.jpg";